import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type {
  SendMfaOtpCodeRequestDto,
  SendMfaOtpCodeResponseDto,
} from '../types';

type UseMfaOtpCodeArgs = UseMutationOptions<
  SendMfaOtpCodeResponseDto,
  Error,
  SendMfaOtpCodeRequestDto
>;

const useMfaIdentityOTP = (args: UseMfaOtpCodeArgs) => {
  const mutation = useMutation({
    ...args,
  });

  return {
    otpCodeData: mutation.data,
    sendOtpCode: mutation.mutateAsync,
    isOtpCodeSubmitting: mutation.isPending,
    isOtpCodeSuccess: mutation.isSuccess,
    isOtpCodeError: mutation.isError,
    otpCodeError: mutation.error,
    data: mutation.data,
    resetOtpCode: mutation.reset,
    mutation,
  };
};

export { useMfaIdentityOTP };
